import { render, staticRenderFns } from "./DebrisDialog.vue?vue&type=template&id=4c473ef6&scoped=true&"
import script from "./DebrisDialog.vue?vue&type=script&lang=js&"
export * from "./DebrisDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c473ef6",
  null
  
)

export default component.exports